<template>
  <slidePopup ref="slidePopup">
<!-- 상품코드 찾기-->
<div>
  <div class="inner">
    <strong class="title">상품코드 찾기</strong>
    <div class="pop_con_wrap scroll_area" style="height:700px;">
      <div class="search">

 
          <!-- 탭 부분 (공통) -->
        <div v-if="!this.destroyTab">
          <div class="tab_radio_wrap w900">
            <div class="tab_radio">
              <div class="custom-radio-02">
                <input type="radio" id="car_lpn"  name="car_lpn"  class="radio" value="TabCarLpn" checked="checked" v-on:click="selectTab('TabCarLpn')"><label for="car_lpn">차량번호</label>
              </div>
              <div class="custom-radio-02">
                <input type="radio" id="car_vin" name="car_vin"  class="radio" value="TabCarVin" v-on:click="selectTab('TabCarVin')"><label for="car_vin">차대번호</label>
              </div>
              <div class="custom-radio-02">
                <input type="radio" id="car_model" name="car_model"  class="radio" value="TabCarModel" v-on:click="selectTab('TabCarModel')"><label for="car_model">모델명 검색</label>
              </div>
              <div class="custom-radio-02">
                <input type="radio" id="car_catalogue" name="car_catalogue"  class="radio" value="TabCarCatalogue" v-on:click="selectTab('TabCarCatalogue')"><label for="car_catalogue">카달로그</label>
              </div>
            </div>
          </div>


          <!-- 선택된 탭의 검색 입력 부분 (탭선택에 따라 바뀜) -->
            <div v-if="this.selectedTab == 'TabCarLpn'">
            <tabCarLpn v-model="this.carInfo"></tabCarLpn>
            </div>

            <div v-if="this.selectedTab == 'TabCarVin'">
            <tabCarVin v-model="this.carInfo"></tabCarVin>
            </div>

            <div v-if="this.selectedTab == 'TabCarModel'">
            <tabCarModel v-model="this.carInfo"></tabCarModel>
            </div>

            <div v-if="this.selectedTab == 'TabCarCatalogue'">
            <tabCarCatalogue v-model="this.carInfo"></tabCarCatalogue> 
            </div>
        </div>
          <!-- <keep-alive>
            <component :is="this.selectedTab" :ref="this.selectedTab" v-model="this.carInfo">
            </component>
          </keep-alive> -->

          <!-- 부품 셀렉트박스 리스트 -->
          <div class="product_img_wrap">
            <div class="img_cell">
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">오일</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall" class="checkbox" @click="pickAllCarParts($event)"><label for="deall"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:200px;">
                    <div class="detail_con">
                      <ul>
                        <li v-for="option in selectBox_options.brandCodeVo" v-bind:value="option.value" v-bind:key="option.text"> 
                          <div class="custom-checkbox">
                            <input type="checkbox" v-bind:id="option.value" v-bind:value="option.value" name="oil"  class="checkbox" @click="pickCarParts($event)"><label v-bind:for="option.value" class="pl25">{{option.text}}</label>
                          </div>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">필터</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall02" class="checkbox"><label for="deall02"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:200px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="be01" class="checkbox"><label for="be01" class="pl25">에어 필터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="be02" class="checkbox"><label for="be02" class="pl25">오일 필터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="be03" class="checkbox"><label for="be03" class="pl25">케빈 필터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="be04" class="checkbox"><label for="be04" class="pl25">연료 필터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="be05" class="checkbox"><label for="be05" class="pl25">미션 필터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="be06" class="checkbox"><label for="be06" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">브레이크</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall02" class="checkbox"><label for="deall02"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:200px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ce01" class="checkbox"><label for="ce01" class="pl25">패드</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ce02" class="checkbox"><label for="ce02" class="pl25">디스크</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ce03" class="checkbox"><label for="ce03" class="pl25">패드센서</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ce04" class="checkbox"><label for="ce04" class="pl25">컨트롤 모듈</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ce05" class="checkbox"><label for="ce05" class="pl25">부스터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ce06" class="checkbox"><label for="ce06" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">점화</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall04" class="checkbox"><label for="deall04"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:150px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="de01" class="checkbox"><label for="de01" class="pl25">점화 플러그</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="de02" class="checkbox"><label for="de02" class="pl25">점화 코일</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="de03" class="checkbox"><label for="de03" class="pl25">점화 케이블</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="de06" class="checkbox"><label for="de06" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">와이퍼</div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">서스펜션</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall06" class="checkbox"><label for="deall06"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:139px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="fe01" class="checkbox"><label for="fe01" class="pl25">쇽업 쇼바</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="fe02" class="checkbox"><label for="fe02" class="pl25">쇼바 마운트</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="fe03" class="checkbox"><label for="fe03" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">스티어링</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall" class="checkbox"><label for="deall"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:200px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae01" class="checkbox"><label for="ae01" class="pl25">파워스트어링 펌프</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae02" class="checkbox"><label for="ae02" class="pl25">타이로드</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae03" class="checkbox"><label for="ae03" class="pl25">스테빌라이저</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae04" class="checkbox"><label for="ae04" class="pl25">컨트롤 암/스트럿/위시본</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae05" class="checkbox"><label for="ae05" class="pl25">허브/베어링</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae06" class="checkbox"><label for="ae06" class="pl25">씰링/리테이너</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ae07" class="checkbox"><label for="ae07" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="img_cell mt10">
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">벨트</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall07" class="checkbox"><label for="deall07"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:139px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ge01" class="checkbox"><label for="ge01" class="pl25">타이밍 벨트 세트</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ge02" class="checkbox"><label for="ge02" class="pl25">V-벨트</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="ge03" class="checkbox"><label for="ge03" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">쿨링</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall08" class="checkbox"><label for="deall08"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:150px;">
                    <div class="detail_con">
                      <ul>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he01" class="checkbox"><label for="he01" class="pl25">라디에어터</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he02" class="checkbox"><label for="he02" class="pl25">콘덴서</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he03" class="checkbox"><label for="he03" class="pl25">워터펌프</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he04" class="checkbox"><label for="he04" class="pl25">서머스탯</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he05" class="checkbox"><label for="he05" class="pl25">자동 휀</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he06" class="checkbox"><label for="he06" class="pl25">냉각수 호스</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he07" class="checkbox"><label for="he07" class="pl25">에어컨 컴프레서</label>
                          </div>
                        </li>
                        <li>
                          <div class="custom-checkbox">
                            <input type="checkbox" id="he08" class="checkbox"><label for="he08" class="pl25">기타</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">가스켓</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall08" class="checkbox"><label for="deall08"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:150px;">
                    <div class="detail_con">
                      <ul>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie01" class="checkbox"><label for="ie01" class="pl25">벨브커버 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie02" class="checkbox"><label for="ie02" class="pl25">실런더헤드 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie03" class="checkbox"><label for="ie03" class="pl25">오일팬 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie04" class="checkbox"><label for="ie04" class="pl25">오일필터 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie05" class="checkbox"><label for="ie05" class="pl25">흡기 매니홀드 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie06" class="checkbox"><label for="ie06" class="pl25">배기 매니홀드 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie07" class="checkbox"><label for="ie07" class="pl25">밸브 가이드씰</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie08" class="checkbox"><label for="ie08" class="pl25">실런트</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ie09" class="checkbox"><label for="ie09" class="pl25">기타</label>
                        </div>
                      </li>
                    </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">엔진기타</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall11" class="checkbox"><label for="deall11"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:150px;">
                    <div class="detail_con">
                      <ul>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je01" class="checkbox"><label for="je01" class="pl25">엔진마운트</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je02" class="checkbox"><label for="je02" class="pl25">발전기</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je03" class="checkbox"><label for="je03" class="pl25">스타트모터</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je04" class="checkbox"><label for="je04" class="pl25">센서류</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je05" class="checkbox"><label for="je05" class="pl25">밸브류</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je06" class="checkbox"><label for="je06" class="pl25">펌프류</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="je07" class="checkbox"><label for="je07" class="pl25">기타</label>
                        </div>
                      </li>
                    </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">트랜스미션</div>
                <div class="pro_detail">
                  <div class="detail_top">
                    <div class="sub_left_wrap">
                      <span>전체</span>
                      <div class="custom-checkbox pl5 vatt">
                        <input type="checkbox" id="deall13" class="checkbox"><label for="deall13"></label>
                      </div>
                    </div>
                  </div>
                  <div class="scroll_area" style="height:150px;">
                    <div class="detail_con">
                      <ul>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ke01" class="checkbox"><label for="ke01" class="pl25">미션마운트</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ke02" class="checkbox"><label for="ke02" class="pl25">오일팬</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ke03" class="checkbox"><label for="ke03" class="pl25">오일팬 가스켓</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ke04" class="checkbox"><label for="ke04" class="pl25">오일필터</label>
                        </div>
                      </li>
                      <li>
                        <div class="custom-checkbox">
                          <input type="checkbox" id="ke07" class="checkbox"><label for="ke07" class="pl25">기타</label>
                        </div>
                      </li>
                    </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img_box">
                <div class="pro_img"></div>
                <div class="pro_text">전구류/베터리</div>
              </div>
              <div class="img_box"></div>
            </div>
          </div>
          <!-- table -->
          <div class="board_list type02 w900">
            <div class="sub_left_wrap">
              <div class="destxt pb10">조회결과 <span>{{this.gridTotal}}</span>건 (브랜드리스트로 일단 조회해둠) </div>
            </div>
            <div class="sub_right_wrap">
              <div class="destxt pb10">담은 주문항목 <span>xx</span>건 </div>
            </div>

            <grid :options="grid_options" v-once></grid>

            <div class="sub_left_wrap">
              <div class="btn_area">
                <a href="javascript:void(0);" class="button white">
                  <span>초기화</span>
                </a>
              </div>
            </div>
            <div class="sub_right_wrap">
              <div class="btn_area dark">
                <a href="javascript:void(0);" class="button dark slide_close" >
                  <span>팝업닫기</span>
                </a>
                <a href="javascript:void(0);" class="button blue">
                  <span>주문항목 담기</span>
                </a>
              </div>
            </div>
          </div>

        </div>
    </div>

  </div>


</div>
<!-- 상품코드 찾기 -->
  </slidePopup>
</template>

<script>
import SlidePopup from '@/components/SlidePopup'
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'
import TabCarLpn from '../../common/partsCodeSearch/TabCarLpn.vue'
import TabCarVin from '../../common/partsCodeSearch/TabCarVin.vue'
import TabCarModel from '../../common/partsCodeSearch/TabCarModel.vue'
import TabCarCatalogue from '../../common/partsCodeSearch/TabCarCatalogue.vue'


export default {
  name : 'partsCodeSearchSlidePopup',
  components: { SlidePopup, Grid, GridModule, Vue, TabCarLpn, TabCarVin, 
                TabCarModel, TabCarCatalogue },
  props: { //부모창으로 부터 받은 속성값
    value : '', //props는 자식이 부모 컴포넌트로부터 넘겨받은 data를 사용 할 수 있게 한다.
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedTab: '',      //탭 이름 초기화
      destroyTab: '',       //탭 초기화 여부
      gridTotal: 0,
      carInfo: [],          //자동차 정보
      carPartsInfo: [],     //부품 정보
      count : 0,            //콤마찍기 counter
      carParts: '',  //선택 부품 콤마구분 string
      carPartsArray: '',    //sql 부품 조회에 사용될 조건
      pushToChildComponent: this.carInfo,  //각 탭에 자동차정보 push
      selectBox_options : { //부품 selectbox 정보
          brandCodeVo : ''
      },
      grid_options : {
        general : {
          id  : 'parts-slide-popup-grid',
          search : '',
          //update : '/brand/update',
          // excel : {
          //   url : '/brand/excel.xls',
          //   fileName : 'brandPopupList'
          // },
          type : {
            isUpdate : false,
            //isHideAdd : true : true,
          },
          PageInfo : {
          },
          params : {
            searchText: ""
          }              
        },
          grid_options : {
              height: 300,
          paging: {
              pagerTotal : false,
              //hidePageList : true,
              pagerSelect : false
          },
              columnMapping : [
                  //{   key : 'brandId',          hidden: true },
                  {   width : '30px',            selectorColumn : true   },
                  {   key : 'brandNo',        title : '로고',   width : '148px' }, 
                  {   key : 'brandId',        title : '구분',   width : '130px' }, 
                  {   key : 'brandName',        title : 'SKN 상품코드',   width : '200px' }, 
                  {   key : 'brandEngNamePrefix',    title : '안성물류',   width : '100px' }, 
                  {   key : 'discountRate',     title : '서울물류',       width : '100px' },
                  {   key : 'discountRate',     title : '일반단가',       width : '100px',    align : 'right' },
                  {   key : 'discountRate',     title : '호환상품',       width : '80px' }
              ]
          }
      }
    }
  },
  created() {
    //자동차 정보
    this.carInfo = [];
    //부품 정보
    this.carPartsInfo = [];
    //주문 정보 가져오기 (아직 만들어지지 않은 쪽임 임의로 세팅)
    this.getCarInfo();
    //자동차 부품 가져오기 (tecdoc인가..?)
    this.getCarPartsInfo();
  },
  mounted: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      // commons.js 적용이 안되어 직접 옮김
      $('.img_box').on('mouseenter', function(){
        $(this).find('.pro_detail').hide();
        $(this).find('.pro_detail').show();
        $(this).addClass('on');
      });
      $('.img_box').on('mouseleave', function(){
          $('.img_box').removeClass('on');
          $('.pro_detail').hide();
      });
    })
  },
  methods : {
    open () {
      this.grid_options.general.search = '';
      this.carName = '';
      this.count = 0;
      this.carParts = '';
      this.carPartsArray = '';
      //일단 하나만 체크 풀기
      $("input[name=oil]:checkbox").prop('checked', '');
      //전체 체크 풀기
      $("input[id=deall]:checkbox").prop('checked', '');


      this.$refs.slidePopup.open();

      this.destroyTab = true;
      this.selectedTab = '';
      this.getGridTotal();

      //스크롤 컨트롤러
      $(".popup .scroll_area,.product_sh .scroll_area").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });

      this.$nextTick(() => {
        this.destroyTab = false;
        this.selectedTab = 'TabCarLpn';
      });
    },
    selectTab(tabName) {
      this.selectedTab = tabName;
    },
    selectCarParts() {

    },
    getCarInfo() {
        let orderId = '20190830000001';
        Vue.httpClient
        .get('/partscodesrch/getcarid', {params : { carId : this.value.carId }})
        .then((result) => {
          if ( result.data.result ) {
            let list = result.data.result.list;
            for(var key in list) {
              //자동차 정보 세팅
              this.carInfo = list[key];
            }
          }
        })
    },
    getCarPartsInfo() {
      //브랜드 코드 데이터 가져와서 셀렉트박스 넣기
      let serverPageInfo = { current :  1, perPage : 9999};
      Vue.httpClient
      .get('/brand/list', {params : serverPageInfo})
      .then((result) => {
        if ( result.data.result ) {
          let list = result.data.result.list;
          let brandCodeVo = [];
          for(var key in list) {
            brandCodeVo.push({'value':list[key].brandNo, 'text':list[key].brandName});
          }
          this.selectBox_options.brandCodeVo = brandCodeVo;
        }
      })
    },
    pickCarParts(e) {
      if(e.target.checked) {

        if(this.count == 0) {
          this.carParts = e.target.id
        } else  {
          this.carParts += ',' + e.target.id;
        }
        console.log("스트링쌓임::" + this.carParts);
        this.carPartsArray = this.carParts.split(',');
        this.count++;

      } else {
        console.log("checked 풀림, 배열 삭제 및 스트링도 삭제");
        for(var i=0; i<this.carPartsArray.length; i++) {
          if(this.carPartsArray[i] == e.target.id) { //기존배열값, 내가 선택한값 비교
            this.carPartsArray.splice(i, 1); //기존 배열에서도 삭제
            this.carParts = this.carPartsArray.join(',');
            this.count--;
          }
        }
        console.log("삭제된 어레이 스트링:::" + this.carParts);
      }
    },
    pickAllCarParts (e) {
        //일단 기존 선택된 carParts들을 초기화시킴
        this.carParts = '';
        this.carPartsArray = '';
        this.count = 0;
        //따로변수 선언하면 오류생김..
        var carPartsAll = ''; 
        var carPartsAllArray = '';
        var carPartsAllcount = 0;
      if(e.target.checked) {
        //모두 체크
        $("input[name=oil]:checkbox").prop('checked', 'checked');
        //checked 값 선택 후 할당
        $("input[name=oil]:checked").each(function() {
          if(carPartsAllcount == 0) {
            carPartsAll = $(this).val();
          } else  {
            carPartsAll += ',' + $(this).val();
          }
          carPartsAllcount++;
        });
        //전체선택결과 배열에 할당
        carPartsAllArray = carPartsAll.split(',');
        //전역변수에 할당
        this.carParts = carPartsAll;
        this.carPartsArray = carPartsAllArray;
        console.log("전체선택::" + this.carParts);
      } else {
        $("input[name=oil]:checkbox").prop('checked', '');
        console.log("전체해제::" + this.carParts);
      }
    },
    getGridTotal() {
        this.gridTotal = 0;
            Vue.httpClient
            .get('/brand/list', {}) //{params : this.grid_options.general.params}
            .then((result) => {
            if ( result.data.result ) {
                this.gridTotal = result.data.result.total;
            }
        })
    }
    // initTab () {
    //   this.$emit('parts-code-search-slide-complete', this.carInfo.carId);
    //   //setTimeout(() => {
    //   //  this.destroyTab = true,
    //   //  this.selectedTab = 'TabCarLpn'
    //   //}, 300);
    //   this.$refs.slidePopup.close();
    // }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/common/partsCodeSearch/PartsCodeSearchSlidePopup.vue